/*
 * Copyright (C) Compliance Audit Systems Limited - All Rights Reserved
 * Unauthorised copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Sudara Fernando <sudara@complianceauditsystems.com>, ${DATE}
 *
 */

import {Component} from '@angular/core';

@Component({
    selector: 'acabim-admin-subscriptions-manager',
    templateUrl: './subscriptions-manager.component.html',
    styleUrls: ['./subscriptions-manager.component.scss']
})
export class SubscriptionsManagerComponent {


}
